module.exports = __webpack_public_path__ + "static/14-00383c9bb100690a66f72fd146753d7f.png";